import { computed, watch } from 'vue';

import { KyJson } from '@eaphone/network';

import { sdkHook } from './index.js';
import { wxConfig } from './lib.js';

function hideMenuItems({ AppMessageShare, TimelineShare, Favorite }) {
  wx.showAllNonBaseMenuItem();

  wx.hideMenuItems({
    menuList: [
      TimelineShare === false ? 'share:timeline' : undefined,
      AppMessageShare === false ? 'share:appMessage' : undefined,
      Favorite === false ? 'favorite' : undefined,
      'copyUrl',
      'openWithQQBrowser',
      'openWithSafari',
      'originPage',
      'readMode',
      'share:email',
      'share:facebook',
      'share:qq',
      'share:QZone',
      'share:weiboApp',
      'share:wechat',
    ]
      .filter(Boolean)
      .map((item) => `menuItem:${item}`),
  });
}

function getSignature(url) {
  return KyJson.get('passport/v1/wxmp/signature', {
    auth: false,
    searchParams: { url, appid: import.meta.env.APP_ID },
  }).then(({ timestamp, nonceStr, signature, appId } = {}) => ({
    timestamp,
    nonceStr,
    signature,
    appId,
  }));
}

function runHook({
  AppMessageShare = false,
  TimelineShare = false,
  Favorite = false,
}) {
  sdkHook()
    .then((sdk) => {
      hideMenuItems({ AppMessageShare, TimelineShare, Favorite });

      if (AppMessageShare === undefined) {
        sdk.updateAppMessageShareData();
      }

      if (TimelineShare === undefined) {
        sdk.updateTimelineShareData();
      }
    })
    .catch(console.error);
}

function afterWechatConfig({
  AppMessageShare = true,
  TimelineShare = true,
  Favorite = false,
  jsApiList = [],
  openTagList = [],
} = {}) {
  wxConfig(getSignature, {
    openTagList,
    jsApiList: [
      ...jsApiList,
      'showAllNonBaseMenuItem',
      'hideMenuItems',
      AppMessageShare === false ? false : 'updateAppMessageShareData',
      TimelineShare === false ? false : 'updateTimelineShareData',
    ].filter(Boolean),
  })
    .then(() => {
      runHook({ AppMessageShare, TimelineShare, Favorite });
    })
    .catch(console.error);
}

export function usePageConfig(route) {
  const fullPath = computed(() => route.fullPath);
  watch(
    fullPath,
    (newPath, oldPath) => {
      if (
        !import.meta.env.WATCHING &&
        newPath &&
        newPath !== '/' &&
        newPath !== oldPath
      ) {
        afterWechatConfig(route.meta?.wechat);
      }
    },
    { immediate: true },
  );
}
